export const APP_CONFIGURATION = {
  APP_CONSTANT: {
    API_URL: "https://gatewayapi.invest19.com/wtl/",
    AUTH_URL: "https://gatewayapi.invest19.com/",
    UAT_AUTH_URL: "https://gatewayapi-uat.worldtradingleagues.com/"
  },
};
